// apiConfig.js
const apiConfig = {
  // BASE_URL: "http://localhost:5000",
  BASE_URL: "https://api.kiashaajewellery.com",
};

export default apiConfig;
